<template>
  <fragment>
    <tr v-if="show" :key="`${getRowKey}-show`">
      <td :style="getPadding()">
        <v-btn v-if="hasChildren(item)" icon @click="changeShowChildren(item)">
          <v-icon>{{
            item.showChildren ? 'mdi-chevron-down' : 'mdi-chevron-right'
          }}</v-icon>
        </v-btn>
        <v-icon v-else-if="hasParent(item)">mdi-circle-small</v-icon>
      </td>
      <td>
        <template>
          <div class="nowrap">
            <el-table-action
              :item="item"
              @editItem="editItem(item)"
              @newItem="newItem(item)"
              @viewItem="editItem(item)"
              @deleteItem="deleteItem(item)"
            />
          </div>
        </template>
      </td>
      <td>{{ item.code }}</td>
      <td>{{ item.institution ? item.institution.code : '' }}</td>
      <td>{{ item.institution_fullname }}</td>
      <td>{{ item.pasis_code }}</td>
      <td style="white-space: break-spaces;">{{ item.title_lt }}</td>
      <td style="white-space: break-spaces;">{{ item.title_en }}</td>
      <td v-if="!fromImport">{{ item.is_identificator }}</td>
      <td>
        <el-table-enum enumName="serviceType" :item="item.type" />
      </td>
      <td>
        <el-table-enum enumName="digitalService" :item="item.digital_service" />
      </td>
      <td v-if="!fromImport">
        <el-table-enum
          enumName="logic"
          :item="logicToString(item.signature_required)"
        />
      </td>
      <td>
        <el-table-enum
          enumName="logic"
          :item="logicToString(item.notarial_only)"
        />
      </td>
      <td>
        <el-table-enum
          enumName="logic"
          :item="logicToString(item.procuration_law)"
        />
      </td>
      <td>
        <el-table-enum
          enumName="active"
          :item="logicToString(item.is_active)"
        />
      </td>
      <td v-if="!fromImport">
        {{ item.nirvars_count }}
      </td>
      <td v-if="!fromImport">
        {{ getActionExtraFieldSetLabel(item) }}
      </td>
      <td>
        {{ item.valid_from }}
      </td>
      <td>
        {{ item.valid_to }}
      </td>
      <td v-if="item.hasOwnProperty('mandate_type_code')">
        {{ item.mandate_type_code }}
      </td>
    </tr>
    <el-table-service-row
      v-for="child in item.children"
      :key="getChildKey(child)"
      :item="child"
      :show="item.showChildren && show"
      :level="getLevel()"
      :fromImport="fromImport"
      @newItem="newItem"
      @editItem="editItem"
      @deleteItem="deleteItem"
    />
  </fragment>
</template>

<script>
import { Fragment } from 'vue-frag'
export default {
  name: 'ElTableServiceRow',
  components: {
    Fragment,
  },
  data() {
    return {
      parentClassModified: null,
    }
  },
  props: {
    fromImport: Boolean,
    item: [Array, Object],
    level: Number,
    show: Boolean,
  },
  computed: {
    getRowKey() {
      return this.item.id || `in_${this.item.item_index}`
    },
  },
  methods: {
    getActionExtraFieldSetLabel(item) {
      const setObj = item.action_extra_field_set || item.actionExtraFieldSet
      if (setObj) {
        const code = setObj.code
        const title = setObj.title
        if (code && title) {
          return `${code} – ${title}`
        }
        return title || code || ''
      }
      const sid = item.action_extra_field_set_id
      return sid != null && sid !== '' ? sid : ''
    },
    logicToString(item) {
      return item ? '1' : '0'
    },
    hasChildren(item) {
      return item.children.length > 0
    },
    hasParent(item) {
      return item.parent_id
    },
    changeShowChildren(item) {
      let logic = !item.showChildren
      this.$set(item, 'showChildren', logic)
    },
    getPadding() {
      let padding = (this.level - 1) * 20
      return `padding-left:${padding}px;`
    },
    getLevel() {
      return this.level + 1
    },
    newItem(item) {
      this.$emit('newItem', item)
    },
    editItem(item, mode) {
      this.$emit('editItem', item)
    },
    deleteItem(item) {
      this.$emit('deleteItem', item)
    },
    getChildKey(child) {
      if (child.id) {
        return `${child.id}-${this.getLevel()}`
      } else {
        return `${child.item_index}-${this.getLevel()}`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
